import React, { memo } from "react";
import { withRouter } from "react-router-dom";

// const textStyle = {
//   // fontFamily: "OpenSans",
//   fontSize: "10px",
//   textAlign: "center",
//   fontWeight: 600,
//   width: '15px',
//   height: '15px',
//   display: 'inline-flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   border: '1px solid transparent',
//   borderRadius: '1em',
//   verticalAlign: 'middle'
// };

// const activeTextStyle = {
//   color: "#fff",
//   backgroundColor: "#28EBC1",
//   borderColor: "#28EBC1"
// };

// const passiveTextStyle = {
//   color: "rgba(30,61,63,0.29)",
//   borderColor: "rgba(30,61,63,0.29)"
// };

const svgStyle = {
  width: '18px',
  height: '18px',
  display: 'inline',
  fontWeight: 600
};

const activeCircleStyle = {fill: '#28EBC1', stroke: '#28EBC1'};
const passiveCircleStyle = {fill: 'none', stroke: 'rgba(30,61,63,0.29)'};
const activeTextStyle = {fill: '#fff'};
const passiveTextStyle = {fill: 'rgba(30,61,63,0.29)'};

const barStyle = {
  borderRadius: "1px",
  display: "inline-block"
};

const percentageBarStyle = percentage => {
  return {
    background: `linear-gradient(90deg, #28EBC1 0%, #28EBC1 50%, rgba(30,61,63,0.09) 50%, rgba(30,61,63,0.09) 100%)`,
    backgroundSize: '200% 100%',
    backgroundPosition: `${100-percentage}% center`,
    transition: 'background-position 0.3s'
  };
};

const barDimensionStyle = {
  width: 45,
  height: 3,
  // borderRadius: "50px",
  margin: "3px 0"
};

function generateSteps(steps, currentStep, progress) {
  let elements = [];
  let i;
  for (i = 1; i < steps; i++) {
    elements.push(generateStepLabel(i, currentStep));
    if (currentStep > i) {
      elements.push(generateSeparator(100));
    } else if (currentStep === i) {
      elements.push(generateSeparator(progress));
    } else {
      elements.push(generateSeparator(0));
    }
  }
  elements.push(generateStepLabel(steps, currentStep));
  return elements;
}

function generateStepLabel(step, currentStep) {
  const isActive = currentStep >= step;
  return (
    <svg viewBox="0 0 2 2"
      style={svgStyle}
    >
      <circle cx="1" cy="1" r="0.95" style={{...(isActive ? activeCircleStyle : passiveCircleStyle), strokeWidth: 0.1}}/>
      {isActive ?
        <path d="M 0.90379043,1.3844316 1.520883,0.76733892 c 0.020955,-0.0209546 0.020955,-0.0549314 0,-0.0758858 L 1.444997,0.61556732 c -0.020954,-0.0209568 -0.054931,-0.0209568 -0.075888,0 L 0.86584816,1.1188282 0.63089081,0.88387069 c -0.0209546,-0.0209546 -0.0549314,-0.0209546 -0.0758884,0 l -0.0758858,0.0758858 c -0.0209546,0.0209546 -0.0209546,0.0549313 0,0.0758858 l 0.34878925,0.3487893 c 0.0209573,0.020958 0.0549313,0.020958 0.0758883,3.3e-6 z" style={activeTextStyle}/> :
        <text x="1" y="1" fontSize="1" textAnchor="middle" dominantBaseline="central" dy="0.07" style={passiveTextStyle}>{step}</text>
      }
    </svg>
  );

  // return (
  //   <span
  //     style={{
  //       ...textStyle,
  //       ...(isActive ? activeTextStyle : passiveTextStyle)
  //     }}
  //   >
  //     {isActive ?
  //       <img src={checkmark} style={{display:'inline'}} /> :
  //           /* 2px padding to make this visually align better */
  //       <span>{step}</span>}
  //   </span>
  // );
}

function generateSeparator(progress) {
  return (
    <span
      style={{
        ...barStyle,
        ...percentageBarStyle(progress),
        ...barDimensionStyle
      }}
    />
  );
}

function Stepper({
  label,
  steps = 5,
  activeStep = 1,
  stepProgress = 0,
  showNavigationButtons = true,
  canGoNext = () => false,
  canGoPrevious = () => false,
  nextStep,
  previousStep,
  history: { goBack, goForward, length }
}) {
  return (
    <div>
      {label && <h6>{label}</h6>}
      {/*
        <div
        className={`inline-block cursor-pointer align-middle font-bold text-3xl mr-5 ${!canGoPrevious() &&
          "text-gray-400"}`}
        onClick={() => {
          goBack();
        }}
      >
        {"<"}
      </div>
      */}
      <div className="inline-block">
        {generateSteps(steps, activeStep, stepProgress)}
      </div>
      {/*
        <div
        className={`inline-block cursor-pointer align-middle font-bold text-3xl ml-5 ${!canGoNext() &&
          "text-gray-400"}`}
        onClick={() => {
          goForward();
        }}
      >
        {">"}
      </div>
      */}
    </div>
  );
}

export default withRouter(memo(Stepper));
